import React from 'react';
import style from './loader.module.scss';

const Loader = ({ isActive = true }) => (
	isActive ? <div className={style.loader} /> : ''
);

export default Loader;
